import { emptyFilters } from '@/utils/controlTower'
import { emptyColumnPreferences } from '@/utils/controlTower'
import { resolveListColumns } from '@/utils/controlTower'

/**
 * Estado de Torre de Control.
 *
 * `status` distingue los cuatro estados que pide el diseño y que antes no
 * existían (la pantalla solo usaba `$q.loading.show()` global):
 * `idle` = "Sin búsquedas", `loading` = pantalla de carga, `ready`, `empty`
 * (búsqueda sin resultados) y `error`.
 */
const initialState = () => ({
  viewType: 'status',
  layout: 'kanban',

  status: 'idle',
  error: null,

  filters: emptyFilters(),
  appliedFilters: null,

  board: { columns: [], meta: null, summary: null },
  list: { rows: [], meta: null, summary: null, sortBy: 'end_date', sortDir: 'asc' },

  columnPreferences: emptyColumnPreferences(),
  listColumns: resolveListColumns(null, 'status'),

  focusedColumnKey: null,

  selection: { active: false, columnKey: null, ids: [] },

  savedFilters: [],
  activeSavedFilterId: null,

  users: { data: [], meta: null, loading: false },
  locations: { data: [], meta: null },
  organizationLocations: { data: [], meta: null },
  areas: [],
  categories: [],

  // Detalle de tarea abierto desde una tarjeta / fila.
  openedTaskId: null,
  openedTask: null,
  isLoadingTask: false
})

export default initialState
